export default __webpack_public_path__ + "static/media/storyreading.ff2f4904.webp";